import React from 'react'

function Contact() {
  return (
    <section class="paralax-mf footer-paralax bg-image sect-mt4 route" >
      <div class="overlay-mf"></div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="contact-mf">
              <div id="contact" class="box-shadow-full">
                <div class="col-md-6">
                  <div class="title-box-2 pt-4 pt-md-0">
                    <h5 class="title-left">
                      Get in Touch

                    </h5><br/>
                    <p>
                Feel free to get in touch with me. I am always open to
                discussing new projects, creative ideas or opportunities to be
                part of your visions.
              </p>   
              <br/>
              <div class="contact-info">
                
                <img
                  class="img-fluid skillsImg"
                  src="img/location.png"
                  alt="icon"
                />    ADDRESS POINT : Udumalpet,Tiruppur,TamilNadu,India
              </div><br/>
              <div class="contact-info">
                <img
                  class="img-fluid skillsImg"
                  src="img/mail.png"
                  alt="icon"
                />    MAIL ME : madhuvalar.govindaraj@gmail.com
              </div>   <br/>
              <div class="contact-info">
                <img
                  class="img-fluid skillsImg"
                  src="img/phone.png"
                  alt="icon"
                />    CALL ME : 7502848705
              </div><br/>
              <div class="contact-info">
                <img
                  class="img-fluid skillsImg"
                  src="img/whatsapp.png"
                  alt="icon"
                />
                Whatsapp : 7502848705
              </div>
              <br/>
              <div class="social">
                <a
                  href="https://www.linkedin.com/in/mathubala-g-771993251/"
                  target="_blank"
                  class="md:ml-6 md:mr-0 mr-6 cursor-pointer mt-4 hover:scale-125 flex flex-col justify-center items-center"
                  ><img alt="" src="img/linkedin.png"
                /></a>
                <a
                  href="https://github.com/Mathubala95"
                  target="_blank"
                  class="md:ml-6 md:mr-0 mr-6 cursor-pointer mt-4 hover:scale-125 flex flex-col justify-center items-center"
                  ><img alt="" src="img/github.png"
                /></a>
              </div>



                  </div>
                  

                 
                </div>
                
              </div>
            </div>
          </div>





        </div>
      </div>


      <footer>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="copyright-box">
                <p class="copyright">&copy; Copyright <strong>Mathubala</strong>. All Rights Reserved</p>
                <div class="credits">

                  Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </section>
  )
}

export default Contact